<template>
    <div class="data-table__item">
        <div>
            <h3>{{ role.name }}</h3>
        </div>

        <div>
            <ul class="data-table__options">
                <li>
                    <span v-if="isProtected"><i class="icon icon-lock"></i> Niet bewerkbaar</span>
                    <router-link :to="{ name: 'editRole', params: { id: role.id } }" class="btn btn-primary" v-permission:manage_roles="currentUser" v-if="!isProtected">Bewerken</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        props: ["role"],

        computed: {
            isProtected() {
                return (this.role.protected === 1);
            },
            ...mapGetters([
                'currentUser',
            ]),
        }
    }
</script>